import { lazy } from "react";
import type { RouteObject } from "react-router";

import { LEGAL_PAGE_ANALYTICS, pageAnalytics } from "@applications/analytics";
import { AnalyticsLayout } from "@applications/AnalyticsLayout";
import { PAGE_ROUTES } from "@applications/routesFromContext";
import { AuthenticationProvider } from "@authentication";

const App = lazy(() => import("./App"));

const DefaultPolicy = lazy(() => import("@pages/PrivacyPolicy/PrivacyPolicy"));
const PrivacyPolicyByLang = lazy(() => import("@pages/PrivacyPolicy/PrivacyPolicyByLang"));
const DefaultTermsAndConditions = lazy(
  () => import("@pages/TermsAndConditions/TermsAndConditions"),
);
const TermsAndConditionsByLang = lazy(
  () => import("@pages/TermsAndConditions/TermsAndConditionsByLang"),
);

export const routes: RouteObject[] = [
  {
    element: (
      <AuthenticationProvider>
        <AnalyticsLayout />
      </AuthenticationProvider>
    ),
    children: [
      // The legal pages are public: they render outside `App`, which forces the CIAM sign-in.
      {
        path: "/privacy-policy",
        handle: { analytics: LEGAL_PAGE_ANALYTICS.privacyPolicy },
        children: [
          { index: true, element: <DefaultPolicy /> },
          { path: ":lang", element: <PrivacyPolicyByLang /> },
          { path: "*", element: <DefaultPolicy /> },
        ],
      },
      {
        path: "/terms-and-conditions",
        handle: { analytics: LEGAL_PAGE_ANALYTICS.termsAndConditions },
        children: [
          { index: true, element: <DefaultTermsAndConditions /> },
          { path: ":lang", element: <TermsAndConditionsByLang /> },
          { path: "*", element: <DefaultTermsAndConditions /> },
        ],
      },
      {
        element: <App />,
        children: [
          ...PAGE_ROUTES.map(({ to, component: Component }) => ({
            path: to,
            element: <Component />,
            handle: { analytics: pageAnalytics(to) },
          })),
          // Unknown paths, including the CIAM `/callback/`, still render `App` so it can run the
          // sign-in flow.
          { path: "*", element: null },
        ],
      },
    ],
  },
];
